import { HourDayHeatmapChart, HourDayHeatmapChartProps } from '../../../renderers/hour-day-heatmap-chart/hour-day-heatmap-chart.component';
import { VENDING_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_DEFINITION } from './vending-package-volume-hour-day-heatmap-chart.definition';
import { VENDING_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_MOCK_DATA } from './vending-package-volume-hour-day-heatmap-chart.mock';

export const VendingPackageVolumeHourDayHeatmapChart = (props: HourDayHeatmapChartProps) => <HourDayHeatmapChart {...props} />;

VendingPackageVolumeHourDayHeatmapChart.definition = VENDING_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_DEFINITION;
VendingPackageVolumeHourDayHeatmapChart.mockData = VENDING_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_MOCK_DATA;
